import { defineAsyncComponent } from "vue";
import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";
import { useUserStore } from "@/stores/user";
/**
 * 仓储管理
 */
const storageRouter: RouteRecordRaw[] = [
    {
        path: "/warehouseSupervision/inventoryQuery",
        name: "WarehouseInventoryQuery",
        component: defineAsyncComponent(() => {
            const userStore = useUserStore();
            if (userStore?.isSAAS) {
                return import("@/components/emptyPage/index.vue");
            } else {
                return import("@/views/pages/warehouseSupervision/storageManagement/inventoryQuery/index.vue");
            }
        }),
        meta: {
            title: "库存查询",
            isNotShowHeader: true,
            keepAlive: true
        }
    },
    {
        path: "/warehouseInbound",
        name: "WarehouseInbound",
        component: defineAsyncComponent(() => {
            const userStore = useUserStore();
            if (userStore?.isSAAS) {
                return import("@/components/emptyPage/index.vue");
            } else {
                return import("@/views/pages/warehouseSupervision/storageManagement/inboundManagement/index.vue");
            }
        }),
        meta: {
            title: "入库管理",
            activeMenu: "WarehouseInbound",
            keepAlive: true,
            pageType: PAGE_TYPE.LIST.code
        }
    },
    {
        path: "/warehouseInbound/detail",
        name: "WarehouseInboundDetail",
        component: () => import("@/views/pages/warehouseSupervision/storageManagement/inboundManagement/detail.vue"),
        meta: {
            title: "入库单详情",
            activeMenu: "WarehouseInbound",
            hidden: true,
            isNotShowHeader: true
        }
    },
    {
        path: "/warehouseInbound/edit",
        name: "WarehouseInboundEdit",
        component: () => import("@/views/pages/warehouseSupervision/storageManagement/inboundManagement/form.vue"),
        meta: {
            title: "修改入库单",
            activeMenu: "WarehouseInbound",
            hidden: true,
            isNotShowHeader: true,
            pageType: PAGE_TYPE.CACHE_FORM.code,
            keepAlive: true
        }
    },
    {
        path: "/warehouseInbound/add",
        name: "WarehouseInboundAdd",
        component: () => import("@/views/pages/warehouseSupervision/storageManagement/inboundManagement/form.vue"),
        meta: {
            title: "新增入库单",
            activeMenu: "WarehouseInbound",
            hidden: true,
            isNotShowHeader: true,
            pageType: PAGE_TYPE.CACHE_FORM.code,
            keepAlive: true
        }
    },
    {
        path: "/warehouseOutbound",
        name: "WarehouseOutbound",
        component: defineAsyncComponent(() => {
            const userStore = useUserStore();
            if (userStore?.isSAAS) {
                return import("@/components/emptyPage/index.vue");
            } else {
                return import("@/views/pages/warehouseSupervision/storageManagement/outboundManagement/index.vue");
            }
        }),
        meta: {
            title: "出库管理",
            activeMenu: "WarehouseOutbound",
            keepAlive: true,
            pageType: PAGE_TYPE.LIST.code
        }
    },
    {
        path: "/warehouseOutbound/detail",
        name: "WarehouseOutboundDetail",
        component: () => import("@/views/pages/warehouseSupervision/storageManagement/outboundManagement/detail.vue"),
        meta: {
            title: "出库单详情",
            activeMenu: "WarehouseOutbound",
            hidden: true,
            isNotShowHeader: true
        }
    },
    {
        path: "/warehouseOutbound/edit",
        name: "WarehouseOutboundEdit",
        component: () => import("@/views/pages/warehouseSupervision/storageManagement/outboundManagement/form.vue"),
        meta: {
            title: "修改出库单",
            activeMenu: "WarehouseOutbound",
            hidden: true,
            isNotShowHeader: true,
            pageType: PAGE_TYPE.CACHE_FORM.code,
            keepAlive: true
        }
    },
    {
        path: "/warehouseOutbound/add",
        name: "WarehouseOutboundAdd",
        component: () => import("@/views/pages/warehouseSupervision/storageManagement/outboundManagement/form.vue"),
        meta: {
            title: "新增出库单",
            activeMenu: "WarehouseOutbound",
            hidden: true,
            isNotShowHeader: true,
            pageType: PAGE_TYPE.CACHE_FORM.code,
            keepAlive: true
        }
    }
];

export default storageRouter;
